import {connect} from 'react-redux';
import App from '../components/App';
import {logout} from '../actions/authorizationAction';

const mapStateToProps = state => {
    return {
        authorized: state.authorization.authorized,
        translationAddEditDialog: state.translation.addEditDialog,
        addLocationDialogOpen: state.addLocation.addLocationDialogOpen,
        app: state.app
    }
};

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(logout())
        }
    }
};

const AppContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(App);

export default AppContainer;
